module.exports = __webpack_public_path__ + "img/black_leather_jacket-400x520.63215741.jpg";